import { Divider, Text } from "@mantine/core";
import { Select } from "src/components/shared/MantineCombobox";
import { useMemo, useRef } from "react";
import Section from "../../components/shared/EntriesGenerator/Section/Section/Section";
import LogbookOverlay from "../LogbookOverlay/LogbookOverlay";
import { useTheme } from "src/hooks";
import { Flex } from "src/styled/shared.styled";

interface SnapshotDisplayProps {
  snapshotHeaders?: any[];
  snapshotEntry?: {
    list: any[];
    lbname: string;
  };
  pageSize?: number;
  onPageSizeChange?: (size: number) => void;
}

const SnapshotDisplay = ({
  snapshotHeaders,
  snapshotEntry,
  pageSize = 25,
  onPageSizeChange,
}: SnapshotDisplayProps) => {
  const resultsRef = useRef<HTMLDivElement>(null);
  const { colors } = useTheme();

  // Create a section object for the Section component (always call useMemo)
  const section = useMemo(() => {
    if (!snapshotEntry || !snapshotHeaders || snapshotEntry.list.length === 0) {
      return null;
    }
    return {
      headers: snapshotHeaders,
      rows: snapshotEntry.list,
      title: "",
      colcount: 0,
      className: "passive readonly-snapshot",
    };
  }, [snapshotEntry, snapshotHeaders]);

  // If no snapshot data, don't render anything
  if (!section || !snapshotHeaders || !snapshotEntry) {
    return null;
  }
  return (
    <Flex mt={80} direction="column">
      <Flex justify="space-between" align="flex-start" mb={10}>
        <Flex direction="column" gap={15}>
          <div
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: colors.grayscaleText,
            }}>
            Historical Snapshot - {snapshotEntry.lbname}
          </div>
          <div
            style={{
              fontSize: 12,
              color: colors.grayscaleText,
              fontStyle: "italic",
            }}>
            This is a read-only view of historical snapshot data
          </div>
        </Flex>
        <Flex gap={20} align="center">
          <div
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: colors.grayscaleText,
            }}>
            Number of entries:
          </div>
          <Select
            maw={130}
            value={String(pageSize)}
            allowDeselect={false}
            data={["25", "50", "100", "250"]}
            onChange={value => {
              onPageSizeChange?.(parseInt(value ?? "25"));
            }}
          />
        </Flex>
      </Flex>

      <Divider my={12} color={colors.grayscaleBorder[0]} />
      <div style={{ position: "relative", textAlign: "center", marginTop: 30 }}>
        <style>{`
        .readonly-snapshot_scroll thead th {
          border-color: ${colors.grayscale[0]} !important;
          background-color: ${colors.grayscale[1]} !important;
          color: ${colors.grayscaleText} !important;
        }
        .readonly-snapshot_scroll tbody td {
          border-color: ${colors.grayscale[1]} !important;
          background-color: ${colors.grayscale[2]} !important;
          color: ${colors.grayscaleText}  !important;
          filter: grayscale(100%);
        }
      `}</style>
        {/* {section && <LogbookOverlay sectionIndex={0} sections={[section]} />} */}
        {section && (
          <Section
            readOnly
            section={section}
            historyRows={[]}
            sIndex={0}
            snapshot
            horizontalScroll
            ref={resultsRef}
          />
        )}
      </div>
    </Flex>
  );
};

export default SnapshotDisplay;
